import React from "react";

export interface SectionCardProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  /**
   * `card` (padrão) desenha a superfície branca com borda e sombra. `plain`
   * entrega só o conteúdo, para quando o bloco já vive dentro de outra
   * superfície — um passo de assistente, um painel — e um card aqui viraria
   * card dentro de card.
   */
  frame?: "card" | "plain";
  /** Esconde título e descrição: quem chama já fez a pergunta. */
  hideHeader?: boolean;
}

export function SectionCard({
  title,
  description,
  children,
  actions,
  className = "",
  frame = "card",
  hideHeader = false,
}: SectionCardProps) {
  const showHeader = !hideHeader && (title || description || actions);
  const isPlain = frame === "plain";

  return (
    <section
      className={
        isPlain
          ? `w-full min-w-0 ${className}`
          : `w-full min-w-0 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm shadow-slate-200/70 md:p-6 ${className}`
      }
    >
      {showHeader && (
        <div
          className={`flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between ${
            isPlain ? "mb-4" : "mb-5"
          }`}
        >
          <div className="min-w-0">
            {title ? (
              isPlain ? (
                <h3 className="min-w-0 text-base font-semibold tracking-tight text-slate-950">
                  {title}
                </h3>
              ) : (
                <div className="flex min-w-0 items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-600" />
                  <h2 className="min-w-0 text-lg font-bold tracking-tight text-slate-950">
                    {title}
                  </h2>
                </div>
              )
            ) : null}
            {description ? (
              <p
                className={`text-sm leading-6 text-slate-500 ${
                  isPlain ? "mt-1" : "mt-2 font-medium"
                }`}
              >
                {description}
              </p>
            ) : null}
          </div>
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      )}
      {children}
    </section>
  );
}
